import { render } from "./ImagePopup.vue?vue&type=template&id=472fa14e"
import script from "./ImagePopup.vue?vue&type=script&lang=js"
export * from "./ImagePopup.vue?vue&type=script&lang=js"

import "./ImagePopup.vue?vue&type=style&index=0&id=472fa14e&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__